export function getApiUrl(): string {

  const { hostname, protocol } = window.location;
  if (hostname === 'localhost') {
    return 'http://localhost:4000/api/';
  }
  return `${protocol}//${hostname}/api/`;
}
